export default "__VITE_ASSET__CCdrnNUp__"